import { render } from "./bookTotal.vue?vue&type=template&id=4e58b4f5"
import script from "./bookTotal.vue?vue&type=script&lang=js"
export * from "./bookTotal.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__